import { register } from 'extendable-media-recorder';
import { connect } from 'extendable-media-recorder-wav-encoder';
import logger from './utils/logger';

let initialized = false;

export async function initializeAudioRecorder() {
  if (initialized) {
    logger.log('Audio recorder already initialized');
    return;
  }

  try {
    await register(await connect());
    initialized = true;
    logger.log('Audio recorder initialized successfully');
  } catch (error) {
    if (error.message && error.message.includes('encoder stored')) {
      logger.warn('Audio encoder already registered, skipping initialization');
      initialized = true;
    } else {
      logger.error('Error initializing audio recorder:', error);
      throw error;
    }
  }
}